export const MAX_LENGTH = 10

export function formatMobileNumber(value: string, countryCode: string): string {
    const cleanedValue = value.replace(/\D/g, '').replace(/^0/, '')

    if (countryCode === '+61') {
        if (cleanedValue.length <= 3) {
            return cleanedValue
        } else if (cleanedValue.length <= 6) {
            return cleanedValue.replace(/^(\d{3})(\d{1,3})$/, '$1 $2')
        } else if (cleanedValue.length <= 10) {
            return cleanedValue.replace(/^(\d{3})(\d{3})(\d{1,3})$/, '$1 $2 $3')
        }
    } else if (countryCode === '+64') {
        if (cleanedValue.length <= 2) {
            return cleanedValue
        } else if (cleanedValue.length <= 5) {
            return cleanedValue.replace(/^(\d{2})(\d{1,3})$/, '$1 $2')
        } else if (cleanedValue.length <= 9) {
            return cleanedValue.replace(/^(\d{2})(\d{3})(\d{1,4})$/, '$1 $2 $3')
        }
    }
    return cleanedValue
}
